import React from "react";

import "./logo.less";
import CommentIcon from "@src/assets/icons/logo-windturbine.svg";
import DualisName from "@src/assets/icons/logo.svg";

const Logo: React.FC = () => {
  return (
    <div className="logo">
      <CommentIcon
        className="logo__wind-turbine"
        data-testid="logo-windturbine"
      />
      <DualisName className="logo__name" data-testid="logo" />
    </div>
  );
};

export default Logo;
